import React, { useState } from "react";
import { AxiosError, AxiosResponse } from "axios";
import { deleteRequest } from "../../../../utils/httpRequest";
import { notification } from "../../../../utils/helpers";
import { Profile } from "../../../../stores/ProfileStore/Types";

interface Props {
  profileResource: Profile;
  showDeleteModal: boolean;
  handleShowDeleteModal: (val: boolean) => void;
}

const DeleteAccount: React.FC<Props> = ({
  profileResource,
  showDeleteModal,
  handleShowDeleteModal,
}) => {
  const [deletingUser, setDeletingUser] = useState(false);
  const cannotDelete =
    profileResource?.subscription?.active &&
    profileResource?.subscription?.number_of_months_left > 0;

  const closeModal = () => {
    setDeletingUser(false);
    handleShowDeleteModal(false);
  };

  const deleteUser = (event) => {
    event.preventDefault();

    if (cannotDelete) {
      return;
    }

    setDeletingUser(true);

    return deleteRequest(`/api/users/${profileResource.id}.json`)
      .then((_response: AxiosResponse) => {
        (window as any).location = "/";
      })
      .catch((_error: AxiosError) => {
        notification("Unable to delete account.", "error");
        setDeletingUser(false);
      });
  };

  return (
    <div
      className={`pw-backdrop ${showDeleteModal ? "is-open" : ""}`}
      id="deleteBackdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="deleteTitle"
      aria-hidden={!showDeleteModal}
    >
      <div className="pw-modal">
        <div className="delete-modal-ic" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 3 L22 20 H2 Z" />
            <line x1="12" y1="10" x2="12" y2="14" />
            <circle cx="12" cy="17" r="0.6" fill="currentColor" />
          </svg>
        </div>
        <h2 id="deleteTitle">Are you 100% sure?</h2>
        {cannotDelete ? (
          <p className="pw-sub">
            Sorry, you can't delete your account while you still have{" "}
            <strong>
              {profileResource.subscription.number_of_months_left} months
            </strong>{" "}
            left on your payment plan. Please email{" "}
            <a href="mailto:help@42courses.com">help@42courses.com</a> and we
            will happily help you.
          </p>
        ) : (
          <p className="pw-sub">
            Clicking Delete account will erase all your certificates, course
            records and information. This cannot be undone or recovered.
          </p>
        )}
        <div className="pw-foot">
          <button
            type="button"
            className="btn btn-ghost btn--sm"
            onClick={closeModal}
          >
            Keep my account
          </button>
          {!cannotDelete && (
            <button
              type="button"
              className={`btn-delete-final ${deletingUser ? "loading" : ""}`}
              disabled={deletingUser}
              onClick={deleteUser}
            >
              Delete account
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteAccount;
